import { tv } from "../../variants/tv.js";
const badgeVariants = tv({
    slots: {
        badgeSlot: 'inline-flex items-center rounded-full',
        textSlot: 'transition',
        iconSlot: 'inline-block transition',
        imageSlot: 'mt-1 mb-1 ml-1 flex-shrink-0 overflow-hidden',
        imageImg: 'h-full w-full rounded-xsm object-cover'
    },
    variants: {
        palette: {
            neutral: {},
            benefit: {},
            customer: {},
            highlight: {},
            urgency: {},
            error: {},
            success: {},
            caution: {},
            marketingBrand: {},
            promoPrimary: {},
            penny: {}
        },
        emphasis: {
            regular: '',
            medium: '',
            bold: ''
        },
        size: {
            sm: {
                badgeSlot: 'min-h-5 px-1 py-0.5',
                textSlot: 'mx-1 text-body3',
                iconSlot: 'h-[16px] w-[16px]',
                imageSlot: 'h-[14px] w-[14px]'
            },
            md: {
                badgeSlot: 'min-h-6 px-1 py-0.5',
                textSlot: 'mx-1 text-body2',
                iconSlot: 'h-[20px] w-[20px]',
                imageSlot: 'h-[14px] w-[14px]'
            }
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-neutral-3',
                textSlot: 'text-neutral-11',
                iconSlot: 'text-neutral-8'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-benefit-3',
                textSlot: 'text-benefit-11',
                iconSlot: 'text-benefit-8'
            }
        },
        {
            palette: 'customer',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-customer-3',
                textSlot: 'text-customer-11',
                iconSlot: 'text-customer-8'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-highlight-3',
                textSlot: 'text-highlight-11',
                iconSlot: 'text-highlight-8'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-urgency-3',
                textSlot: 'text-urgency-11',
                iconSlot: 'text-urgency-8'
            }
        },
        {
            palette: 'error',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-error-3',
                textSlot: 'text-error-11',
                iconSlot: 'text-error-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-caution-3',
                textSlot: 'text-caution-11',
                iconSlot: 'text-caution-9'
            }
        },
        {
            palette: 'success',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-success-3',
                textSlot: 'text-success-11',
                iconSlot: 'text-success-8'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-marketingBrand-3',
                textSlot: 'text-marketingBrand-11',
                iconSlot: 'text-marketingBrand-8'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-promoPrimary-3',
                textSlot: 'text-promoPrimary-11',
                iconSlot: 'text-promoPrimary-8'
            }
        },
        {
            palette: 'penny',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-penny-3',
                textSlot: 'text-penny-9',
                iconSlot: 'text-penny-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-neutral-1',
                textSlot: 'text-neutral-11',
                iconSlot: 'text-neutral-11'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-benefit-1',
                textSlot: 'text-benefit-11',
                iconSlot: 'text-benefit-11'
            }
        },
        {
            palette: 'customer',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-customer-1',
                textSlot: 'text-customer-11',
                iconSlot: 'text-customer-11'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-highlight-1',
                textSlot: 'text-highlight-11',
                iconSlot: 'text-highlight-11'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-urgency-1',
                textSlot: 'text-urgency-11',
                iconSlot: 'text-urgency-11'
            }
        },
        {
            palette: 'error',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-error-1',
                textSlot: 'text-error-11',
                iconSlot: 'text-error-11'
            }
        },
        {
            palette: 'success',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-success-1',
                textSlot: 'text-success-11',
                iconSlot: 'text-success-11'
            }
        },
        {
            palette: 'caution',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-caution-1',
                textSlot: 'text-caution-11',
                iconSlot: 'text-caution-8'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-marketingBrand-1',
                textSlot: 'text-marketingBrand-11',
                iconSlot: 'text-marketingBrand-8'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-promoPrimary-1',
                textSlot: 'text-promoPrimary-11',
                iconSlot: 'text-promoPrimary-8'
            }
        },
        {
            palette: 'penny',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-penny-1',
                textSlot: 'text-penny-9',
                iconSlot: 'text-penny-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-neutral-8',
                textSlot: 'text-neutral-1',
                iconSlot: 'text-neutral-1'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-benefit-8',
                textSlot: 'text-benefit-1',
                iconSlot: 'text-benefit-1'
            }
        },
        {
            palette: 'customer',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-customer-8',
                textSlot: 'text-customer-1',
                iconSlot: 'text-customer-1'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-highlight-8',
                textSlot: 'text-highlight-1',
                iconSlot: 'text-highlight-1'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-urgency-8',
                textSlot: 'text-urgency-1',
                iconSlot: 'text-urgency-1'
            }
        },
        {
            palette: 'error',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-error-8',
                textSlot: 'text-error-1',
                iconSlot: 'text-error-1'
            }
        },
        {
            palette: 'caution',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-caution-7',
                textSlot: 'text-caution-11',
                iconSlot: 'text-caution-12'
            }
        },
        {
            palette: 'success',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-success-8',
                textSlot: 'text-success-1',
                iconSlot: 'text-success-1'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-marketingBrand-8',
                textSlot: 'text-marketingBrand-1',
                iconSlot: 'text-marketingBrand-1'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-promoPrimary-8',
                textSlot: 'text-promoPrimary-1',
                iconSlot: 'text-promoPrimary-1'
            }
        },
        {
            palette: 'penny',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-penny-8',
                textSlot: 'text-penny-1',
                iconSlot: 'text-penny-1'
            }
        }
    ],
    defaultVariants: {
        palette: 'neutral',
        emphasis: 'medium',
        size: 'sm'
    }
});
const badgeSizes = Object.keys(badgeVariants.variants.size);
const badgePalettes = Object.keys(badgeVariants.variants.palette);
const badgeEmphases = Object.keys(badgeVariants.variants.emphasis);
export { badgeEmphases, badgePalettes, badgeSizes, badgeVariants };
